/* tslint:disable */

// @ts-nocheck
import * as PIXI from 'pixi.js';

function initHoverTexture(sprite) {
  sprite._hoverTexture = {};
  sprite.interactive = true;

  let originalTexture;

  sprite.on('mouseover', () => {
    if (!sprite._hoverTexture) return;
    originalTexture = sprite.texture;
    sprite.texture = PIXI.Texture.from(sprite._hoverTexture.frame);
  });

  sprite.on('mouseout', () => {
    if (!sprite._hoverTexture) return;
    sprite.texture = originalTexture;
  });
}

function initClickTexture(sprite) {
  sprite._clickTexture = {};
  sprite.interactive = true;

  let originalTexture;

  sprite.on('pointerdown', () => {
    if (!sprite._clickTexture) return;
    originalTexture = sprite.texture;
    sprite.texture = PIXI.Texture.from(sprite._clickTexture.frame);
  });

  sprite.on('pointerup', () => {
    if (!sprite._clickTexture) return;
    sprite.texture = originalTexture;
  });
}

Object.defineProperty(PIXI.Sprite.prototype, 'hoverTexture', {
  set(frame: string) {
    !this._hoverTexture && frame && initHoverTexture(this);
    this._hoverTexture.frame = frame;
  },
  get() {
    return this._hoverTexture?.frame;
  },
});

Object.defineProperty(PIXI.Sprite.prototype, 'clickTexture', {
  set(frame: string) {
    !this._clickTexture && frame && initClickTexture(this);
    this._clickTexture.frame = frame;
  },
  get() {
    return this._clickTexture?.frame;
  },
});
